
// Mutations
export const BINDCHARALTNAMES = 'BINDCHARALTNAMES'
export const UNBINDCHARALTNAMES = 'UNBINDCHARALTNAMES'

export const RESETCHARALTNAMES = 'RESETCHARALTNAMES'

// Actions
export const SETCHARALTNAME = 'SETCHARALTNAME';
export const DELETECHARALTNAME = 'DELETECHARALTNAME';


import db from '../../firebase/firebase'
import {
  bindArrayBase,
  removeBoundFromObject,
  updateBoundInObject } from '../helpers/binding';
import { snapshots2objects } from '../helpers/general'

export default {
  state: () => ({
    charaltnames: {},
  }),

  getters: {
    getCharAltNameObj: ( state ) => ( playerid, charclass ) => {
      if( !state.charaltnames[ playerid ] ) return false
      return state.charaltnames[ playerid ][ charclass ]
    },
    getSignupName: ( state, getters, rootState, rootGetters ) => ( signup ) => {
      if( !rootState.localStorage.forceMainNames ) {
        let altnameobj = getters.getCharAltNameObj( signup.playerid, rootGetters.getSpecClass( signup.spec ) )
        if( altnameobj && altnameobj.name ) {
          return altnameobj.name
        }
      }
      return signup.name
    }
  },

  mutations: {
    addBoundCharAltNameBatch: ( state, arrayOfSnapshots ) => {
      const arrayOfObjects = snapshots2objects( arrayOfSnapshots )
      state.charaltnames = mergeWith( arrayOfObjects, state.charaltnames )
    },
    removeBoundCharAltName: ( state, { snapshot } ) => removeBoundFromObject( state.charaltnames, snapshot ),
    updateBoundCharAltName: ( state, { snapshot } ) => updateBoundInObject( state.charaltnames, snapshot ),

    [RESETCHARALTNAMES] ( state ) {
      state.charaltnames = {}
    },
  },

  actions: {
    async [BINDCHARALTNAMES] ( { commit }, guild ) {
      const ref = db.ref( 'guildCharAltNames/' + guild['.key'] )
      return bindArrayBase( ref, commit, 'CharAltName', true, false, false, null )
    },
    [UNBINDCHARALTNAMES] ( { rootState } ) {
      let guild = rootState.guilds.selectedGuild
      if( guild ) {
        db.ref( 'guildCharAltNames/' + guild['.key'] ).off()
      }
    },
    
    [SETCHARALTNAME] ( context, { guild, playerid, charclass, isalt, name } ) {
      if( guild && playerid && charclass ) {
        db.ref( 'guildCharAltNames/' + guild['.key']
                + '/' + playerid + '/' + charclass ).set( { isalt, name } )
      }
    },
    [DELETECHARALTNAME] ( context, { guild, playerid, charclass } ) {
      if( guild && playerid && charclass ) {
        db.ref( 'guildCharAltNames/' + guild['.key'] +
          '/' + playerid + '/' + charclass ).remove()
      }
    },

  },
}

function mergeWith( arrayOfObjects, charaltnames ) {

  let newcharaltnames = { ...charaltnames }

  for( let charAltNameObj of arrayOfObjects ) {

    let playerid = charAltNameObj['.key']
    newcharaltnames[ playerid ] = {... charAltNameObj}

  }

  return newcharaltnames
}
